import { useMemo, useState } from 'react';

import { Form } from 'antd';

import { useConnectorTypes, useConnectorTypeSchema } from '@/entities/connector';
import type { UpdateConnectorRequest } from '@/entities/connector';

export const useConnectorForm = () => {
  const [form] = Form.useForm<UpdateConnectorRequest>();
  const selectedType = Form.useWatch('type', form);

  const [showConfigJson, setShowConfigJson] = useState(false);

  const { data: connectorTypes } = useConnectorTypes();
  const connectorTypeItems = connectorTypes?.items;

  const {
    data: connectorTypeSchema,
    isPending: isSchemaLoading,
    isError: isSchemaError,
  } = useConnectorTypeSchema({
    type: selectedType ?? '',
    enabled: !!selectedType,
  });

  const schemaFields = connectorTypeSchema?.fields ?? [];

  const connectorTypeOptions = useMemo(() => {
    if (!connectorTypeItems) return [];
    return connectorTypeItems.map((item) => ({
      value: item.type,
      label: item.displayName,
    }));
  }, [connectorTypeItems]);

  return {
    form,
    selectedType,
    showConfigJson,
    setShowConfigJson,
    connectorTypeOptions,
    schemaFields,
    isSchemaLoading,
    isSchemaError,
  };
};
